export const htmlString = "<!-- import {MyModel as ViewModel} from './widget' -->\n<div class=\"@@ @@@\" >\n    (Platzhalter)\n</div>";